export default __webpack_public_path__ + "static/media/Protocol2.6feb0981.png";